import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=3f601a74&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "./Footer.vue?vue&type=style&index=0&id=3f601a74&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f601a74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins_home/workspace/joinmc-html-develop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f601a74')) {
      api.createRecord('3f601a74', component.options)
    } else {
      api.reload('3f601a74', component.options)
    }
    module.hot.accept("./Footer.vue?vue&type=template&id=3f601a74&scoped=true", function () {
      api.rerender('3f601a74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Layout/common/Footer.vue"
export default component.exports